import React from 'react';
import cn from 'classnames';

import Typography from '../../Typography';
import BaseMenuItem from '../BaseMenuItem';
import { renderMenuItemIcon } from '../renderers';
import { MenuItemProps } from './types';
import { getMenuItemClasses, getMenuItemPadding } from './utils';

function MenuItem(props: MenuItemProps) {
  const {
    appearance = 'primary',
    as,
    asProps,
    className,
    endIcon,
    EndIcon,
    label,
    overrides,
    startIcon,
    StartIcon,
    ...rest
  } = props;

  const classes = React.useMemo(() => getMenuItemClasses(appearance), [appearance]);

  const hasStartIcon = Boolean(startIcon || StartIcon);
  const hasEndIcon = Boolean(endIcon || EndIcon);
  const itemPadding = getMenuItemPadding({ hasEndIcon, hasStartIcon });

  return (
    <BaseMenuItem
      button
      component={as}
      {...asProps}
      className={cn(classes.root, itemPadding, className)}
      {...rest}>
      {renderMenuItemIcon({ classes: classes.startIcon, icon: startIcon, Icon: StartIcon })}
      <Typography className={classes.label} variant="body-short-02" {...overrides?.Label}>
        {label}
      </Typography>
      {renderMenuItemIcon({ classes: classes.endIcon, icon: endIcon, Icon: EndIcon })}
    </BaseMenuItem>
  );
}

export { MenuItemProps };
export default React.memo(MenuItem);
